import { render, staticRenderFns } from "./MyTaskCalendar.vue?vue&type=template&id=1146989c&scoped=true"
import script from "./MyTaskCalendar.vue?vue&type=script&lang=js"
export * from "./MyTaskCalendar.vue?vue&type=script&lang=js"
import style0 from "./MyTaskCalendar.vue?vue&type=style&index=0&id=1146989c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1146989c",
  null
  
)

export default component.exports